import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { coursesData } from "../../../data";

import "./Courses.scss";

import Navbar from "../../templates/Navbar/Navbar";
import Footer from "../../templates/Footer/Footer";

import Courses from "../../templates/Courses/Courses";
import Title from "../../UI/organisms/Title/Title";

const CoursesPage = () => {
  const { op } = useParams();
  const [data, setData] = React.useState(coursesData("pt", `courses`));
  const publicUrl = process.env.PUBLIC_URL;

  const validate = (op: string | undefined, type: string) => {
    const { pathname } = window.location;

    if (pathname === "/catalogo") return true;
    if (pathname === "/cursos/online" && type === "courses") return true;
    if (pathname === "/cursos/eventos" && type === "events") return true;
    if (pathname === "/livros" && type === "books") return true;

    return false;
  };

  useEffect(() => {
    if (window.location.pathname === "/cursos") {
      window.location.href = "/catalogo";
    }

    if (op && op !== "eventos" && op !== "online") {
      window.location.href = "/catalogo";
    }

    setData(coursesData("pt", `courses`));

    document.title = "Nossos Cursos Onlines || Instituto Valquiria Arenas";
    document.querySelector("body")?.classList.add("all-courses-page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Navbar />
      <section id="banner">
        <img
          src={`${publicUrl}/${data?.banner.image}`}
          alt="Banner clientes e serviços"
        />
        {data?.banner.title && window.location.pathname === "/catalogo" && (
          <Title info={data?.banner.title} tag="h1" />
        )}
      </section>

      {validate(op, "events") && data?.events && (
        <Courses type="events" slick={data.events.slick} />
      )}
      {validate(op, "courses") && data?.courses && (
        <Courses type="courses" slick={data.courses.slick} />
      )}
      {validate(op, "books") && data?.books && (
        <Courses type="books" slick={data.books.slick} />
      )}

      <Footer />
    </>
  );
};

export default CoursesPage;
